import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import logo from "../../logo.jpg";
import { Image } from "react-bootstrap";
import GetProfile from "../../Api/Speakers/Profile/GetProfile";

const Sidebar = () => {
  const { t, i18n } = useTranslation();
  const direction = i18n.language === "ar" ? "rtl" : "ltr";
  const navigate = useNavigate();
  const [profileImage, setProfileImage] = useState("");
  const [profile, setProfile] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));
  const [userRole, setUserRole] = useState(null);
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const handleLogin = () => {
      const token = localStorage.getItem("token");
      setIsLoggedIn(!!token);

      if (token) {
        GetProfile.get()
          .then((response) => {
            setUserRole(response.userRole);
            setProfile(response);
            setUserName(
              i18n.language === "ar"
                ? response.arabicFullName
                : response.englishFullName
            );
            setProfileImage(response.profileImage || "");
          })
          .catch((error) => {
            console.error("خطأ في جلب بيانات المستخدم:", error);
          });
      }
    };

    handleLogin();

    window.addEventListener("user-logged-in", handleLogin);

    return () => {
      window.removeEventListener("user-logged-in", handleLogin);
    };
  }, []);

  useEffect(() => {
    if (profile) {
      setUserName(
        i18n.language === "ar"
          ? profile.arabicFullName
          : profile.englishFullName
      );
    }
  }, [i18n.language, profile]);


  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
    navigate("/admin-login");
  };

  
  return (
    <aside className="sidebar">
      {/* Header */}
      <div
        className="sidebar-header d-flex align-items-center justify-content-between"
        dir={direction}
      >
        <Link to="/dashboard" className="brand d-flex align-items-center">
          <img
            src={logo}
            alt="Mutahadithun"
            height="40"
            style={{ maxHeight: "95px", width: "auto" }}
          />
          <span className="ms-3 fs-5 fw-bold text-white">متحدثون</span>
        </Link>
        <button id="close-sidebar" className="btn p-0">
          <i className="fas fa-times fs-5 text-white"></i>
        </button>
      </div>

      {/* User Info */}
      <div className="sidebar-user text-center">
        {profileImage && (
          <Image
            src={profileImage}
            alt="User"
            roundedCircle
            width="30"
            height="30"
            className="me-2"
          />
        )}
        {userName && <span>{userName}</span>}
        <div className="d-flex justify-content-center mt-2">
          <button
            className="btn btn-sm btn-outline-light rounded-circle mx-1"
            title="الإعدادات"
          >
            <i className="fas fa-cog"></i>
          </button>
          <button
            className="btn btn-sm btn-outline-light rounded-circle mx-1"
            title="البريد"
          >
            <i className="fas fa-envelope"></i>
          </button>
          <button
            className="btn btn-sm btn-outline-light rounded-circle mx-1"
            onClick={handleLogout}
            title={t("logout")}
          >
            <i className="fas fa-sign-out-alt"></i>
          </button>
        </div>
      </div>

      {/* Navigation Menu */}
      <div className="sidebar-menu">
        <ul className="nav flex-column">
          <li className="menu-item">
            <Link to="/dashboard/statistics" className="nav-link">
              <i className="fas fa-tachometer-alt"></i>
              <span>{t("sidebar.dashboard")}</span>
            </Link>
          </li>
          <li className="menu-item">
            <Link to="/dashboard/industry-management" className="nav-link">
              <i className="fas fa-th-large"></i>
              <span>{t("domains")}</span>
            </Link>
          </li>
          <li className="menu-item">
            <Link to="/dashboard/news-management" className="nav-link">
              <i className="fas fa-newspaper"></i>
              <span>{t("sidebar.news")}</span>
            </Link>
          </li>
           <li className="menu-item">
            <Link to="/dashboard/users-management" className="nav-link">
              <i className="fas fa-users"></i>
              <span>{t("sidebar.users")}</span>
            </Link>
          </li>
          <li className="menu-item">
            <Link to="#" className="nav-link">
              <i className="fas fa-calendar-alt"></i>
              <span>{t("sidebar.events")}</span>
            </Link>
          </li>
          <li className="menu-item">
            <Link to="#" className="nav-link">
              <i className="fas fa-blog"></i>
              <span>{t("sidebar.blog")}</span>
            </Link>
          </li>
          <li className="menu-item">
            <a
              href="/"
              className="nav-link"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fas fa-external-link-alt"></i>
              <span>{t("sidebar.mainSite")}</span>
            </a>
          </li>
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
